import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { onSavePress, onUnsavePress } from "@/api/srpFilter";
import "../../common/outbid/OutBidCard.css";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import { markInternalNavigation } from "@/utils/attributionCapture";
import { store } from "@/store/store";
import LoadedText from "@/components/loader/LoadedText";
import LoadingText from "@/components/loader/LoadingText";
import OutBidHeartIcon from "../../../../public/assets/svg/outbid/OutBidHeartIcon";
import {
  setAlerts,
  setProfileInfo,
  setSelectedAlert,
} from "@/redux/user/userSlice";
import { getAlertData, resetMessageCount } from "@/api/alerts";
import { getUserProfile } from "@/api/myProfile";
import CountdownTimer from "@/components/srp/CardComponents/CountdownTimer";
import { formatMoney } from "@/utils/numCommas";
import { FaHeart } from "react-icons/fa";
import { navigateToProperty } from "@/utils/propertyNavigation";


const DEFAULT_IMAGE = "/assets/images/imageOnTheWay.webp";

// Separate component for alert content


const AlertContent = ({ alertType, message, formattedLastBidAmount, searchBy, lastNotifiedOn, newPropertyCount, propertyAddress, baseSearchUrl, cardIndex }) => {
  switch (alertType) {


    case "SAVE_SEARCH":
      return (
       <div id={`alert-save-search-${cardIndex}`} style={{ cursor: 'pointer' }} onClick={(e) => { markInternalNavigation(); window.open('/' + baseSearchUrl + "?sort=TimeLeftHL"); }}>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">New Property Added!</h3>
          <p id={`alert-description-${cardIndex}`} className="home-most-recent-outbid" title={newPropertyCount + " new Properties were added to your save search " + searchBy + " on " + lastNotifiedOn}>
            {newPropertyCount + " new Properties were added to your save search " + searchBy + " on " + lastNotifiedOn}
          </p>
        </div>
      );

    case "CIF_REMINDER":
      return (
        <>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">Complete you contact information</h3>


          <p id={`alert-description-${cardIndex}`} className='home-most-recent-cif'>{""}Complete you contact information
            Congrats, your bid for the property

            <span style={{ fontSize: 18 }} className='cif-property-description'>{" " + propertyAddress + " "}</span>

            has been submitted successfully! Please provide now your contact information to process the closing sooner in the event your bid is selected by the seller.</p>

          {/* <p className="home-most-recent-outbid">
            {"Complete you contact information Congrats, your bid for the property " + propertyAddress + " has been submitted successfully! Please provide now your contact information to process the closing sooner in the event your bid is selected by the seller. " }
          </p> */}
        </>
      );

    case "OUTBID":
      return (
        <>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">{message}</h3>
          <p id={`alert-description-${cardIndex}`} className="home-most-recent-outbid" title={`Your most recent bid was $${formattedLastBidAmount}`}>
            Your most recent bid was ${formattedLastBidAmount}
          </p>
        </>
      );
    case "BACKUPBID":
      return (
        <>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">Backup bid below seller limit</h3>
          <p id={`alert-description-${cardIndex}`} className="home-most-recent-outbid" title={`Your most recent bid was $${formattedLastBidAmount}`}>
            Your most recent bid was ${formattedLastBidAmount}
          </p>
        </>
      );
    case "BACKUP_BID_EXPIRY":
      return (
        <>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">Your backup bid will expire soon</h3>
          <p id={`alert-description-${cardIndex}`} className="home-most-recent-outbid" title="Extend your backup bid for this auction">
            Extend your backup bid for this auction
          </p>
        </>
      );

    case "DRIVEN_BID_WATCHER_ALERT":
      return (
        <>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">Bidding started for saved property</h3>
          <p id={`alert-description-${cardIndex}`} className="home-most-recent-outbid" title="An opening bid was just placed for the below property. Don't let it get away.">
            An opening bid was just placed for the below property. Don't let it get away.
          </p>
        </>
      );

    default:
      return (
        <>
          <h3 id={`alert-message-${cardIndex}`} className="home-outbid-message">Last chance!</h3>
          <p id={`alert-description-${cardIndex}`} className="home-most-recent-outbid" title="You saved this property.">You saved this property.</p>
        </>
      );
  }
};

// Separate component for bid details
const BidDetails = ({ bidCenterAlertDetails, cardIndex }) => {
  const {
    currentHighestBid,
    formattedCurrentHighestBid,
    formattedNextpossibleBidAmount,
  } = bidCenterAlertDetails || {};

  if (currentHighestBid) {
    return (
      <>
        <span id={`alert-bid-title-${cardIndex}`} className="curr-title">Current Highest Bid</span>
        <p id={`alert-bid-price-${cardIndex}`} className="curr-price">${formattedCurrentHighestBid}</p>
      </>
    );
  }

  if (formattedNextpossibleBidAmount) {
    return (
      <>
        <span id={`alert-bid-title-${cardIndex}`} className="curr-title">Starting Bid</span>
        <p id={`alert-bid-price-${cardIndex}`} className="curr-price">${formattedNextpossibleBidAmount}</p>
      </>
    );
  }

  return null;
};

const HomeAlertCard = ({ item, cardIndex }) => {
  const dispatch = useDispatch();

  const state = store.getState();
  const userID = state?.user?.user?.realbidUserId;

  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(DEFAULT_IMAGE);
  const [isFav, setIsFav] = useState(item?.favouritedProperty);

  useEffect(() => {
    if (item?.imageUrl) {
      setImageUrl(item.imageUrl);
    }
  }, [item]);

  const getFormattedAddress = (propertyAddress) => {
    if (!propertyAddress) return "N/A";
    const { streetNumber, streetName, city, state, zip } = propertyAddress;
    return `${streetNumber || ""} ${streetName || ""}, ${city || ""}, ${state || ""
      } ${zip || ""}`.trim();
  };

  const handleFavoriteToggle = async () => {
    try {
      if (isFav) {
        const response = await onUnsavePress({ propertyId: item.propertyId });
        if (response === "success") {
          trackApiCall({
            eventName: `favourite_property_unsaved`,
            eventCategory: "Home Page 2.0",
            eventSource: `home_page_alerts`,
            eventLabel: `Property Id: ${item.propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: `favourite_property_unsave_error`,
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${item.propertyId}`,
          });
        }
      } else {
        trackButtonClick({
          eventName: `favourite_property_save_click`,
          eventCategory: "Home Page 2.0",
          eventSource: `home_page_alerts`,
          eventLabel: `Property Id: ${item.propertyId}`,
        });
        const response = await onSavePress({ propertyId: item.propertyId });
        if (response === "success") {
          trackApiCall({
            eventName: `favourite_property_saved`,
            eventCategory: "Home Page 2.0",
            eventSource: `home_page_alerts`,
            eventLabel: `Property Id: ${item.propertyId}`,
          });
        } else {
          trackApiCall({
            eventName: `favourite_property_save_error`,
            eventCategory: "Error",
            eventSource: `Error - ${
              response?.message || "Data Initialization Failed"
            }`,
            eventLabel: `Property Id: ${item.propertyId}`,
          });
        }
      }
      setIsFav(!isFav);
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  const handleNavigateToPDP = (type) => {
    trackButtonClick({
      eventName: "alert_section_property_click",
      eventCategory: "Home Page 2.0",
      eventSource: `Alert ${type} click`,
      eventParams: { property_action: type },
      eventLabel: `Property position: ${cardIndex + 1}`,
    });
    navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus);
  };

  const handleAlertRefresh = () => {
    getAlertData().then((res) => {
      dispatch(
        setAlerts({
          ...res,
          alerts: [...res.alerts],
        })
      );
    });
    resetMessageCount(userID);
    getUserProfile().then((pdata) => {
      dispatch(setProfileInfo(pdata?.data));
    });
  };

  // Separate component for action button
  const ActionButton = ({ alertType, data }) => {
    const buttonText = {
      BACKUPBID: "Update Backup Bid",
      BACKUP_BID_EXPIRY: "Extend Backup Bid",
      DEFAULT: "Place Bid",
    };

    return (
      <button
        type="button"
        id={`home-alert-action-btn-${cardIndex}`}
        className="btn btn-thm outbid-btn home-outbid-btn"

        data-bs-toggle="offcanvas"
        data-bs-target="#alertsSidebarListing"
        aria-controls="alertsSidebarListing"
        onClick={() => {
          dispatch(setSelectedAlert(data));
          handleAlertRefresh();
        }}
      >
        {isLoading ? (
          <span className="d-flex align-items-center justify-content-center" style={{ width: '100%', textAlign: 'center' }}>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
            Processing...
          </span>
        ) : (
          <span className="d-flex align-items-center justify-content-center" style={{ width: '100%', textAlign: 'center' }}>
            {buttonText[alertType] || buttonText.DEFAULT}
          </span>
        )}
      </button>
    );
  };

  return (
    <div id={`alert-card-${cardIndex}`} className="outbid-card outbid-card-home">
      <div id={`alert-content-${cardIndex}`} className={`px-3 pt-4 ${item.type === "SAVE_SEARCH" ? "align-items-center align-content-center justify-content-center text-center h-100" : ""}`}>
        <AlertContent
          alertType={item?.alertType ? item?.alertType : item?.type}
          message={item?.message}
          searchBy={item?.saveSearchResponse?.searchBy}
          lastNotifiedOn={item?.lastNotifiedOn}
          formattedLastBidAmount={item?.formattedLastBidAmount}
          newPropertyCount={item?.newPropertyCount}
          propertyAddress={getFormattedAddress(item?.propertyAddress)}
          baseSearchUrl={item?.saveSearchResponse?.baseSearchUrl}
          cardIndex={cardIndex}
        />

        {item.type !== "SAVE_SEARCH" && item.type !== "CIF_REMINDER" && (
          <>
            <div id={`alert-property-data-${cardIndex}`} className="outbid-property-data">
              <div>
                <div className="home-alert-image">
                  <img
                    id={`alert-property-img-${cardIndex}`}
                    src={imageUrl}
                    alt="property-image"
                    onError={() => setImageUrl(DEFAULT_IMAGE)}
                    className="home-alert-image"
                    onClick={() => handleNavigateToPDP("image")}
                  />
                  <div
                    id={`alert-fav-icon-${cardIndex}`}
                    className="fav-icons-outbid cursor-pointer mt-1"
                    onClick={handleFavoriteToggle}
                  >
                   <FaHeart
                     color={isFav ? "#ff5a5f" : "#888D91"}
                       className="cursor-pointer"
                      size={18} />
                  </div>
                </div>

              </div>
              <div className="home-outbid-right-section">
                <div className="home-property-info">
                  <p
                    id={`alert-address-1-${cardIndex}`}
                    className="outbid-address-home"
                    onClick={() => handleNavigateToPDP("address")}
                  >
                    {`${item?.propertyAddress?.streetNumber || ""} ${item?.propertyAddress?.streetName || ""}`}
                  </p>
                  <p
                    id={`alert-address-2-${cardIndex}`}
                    className="outbid-address-home"
                    onClick={() => handleNavigateToPDP("address")}
                  >
                    {`${item?.propertyAddress?.city || ""}, ${item?.propertyAddress?.state || ""} ${item?.propertyAddress?.zip || ""}`}
                  </p>
                  {item?.bidCenterAlertDetails?.auctionTimeLeft != null && item?.bidCenterAlertDetails?.auctionTimeLeft !== 0 && (
                    <div id={`alert-timer-${cardIndex}`} className="home-property-info mt10">
                      <CountdownTimer
                        until={item?.bidCenterAlertDetails?.auctionTimeLeft / 1000}
                        isRecommendedProperties={true}
                      />
                    </div>
                  )}
                </div>

              </div>
            </div>
            <div id={`alert-bid-section-${cardIndex}`} className="bid-price-button-row">
              <div className="curr-higest-outbid">
                <BidDetails bidCenterAlertDetails={item?.bidCenterAlertDetails} cardIndex={cardIndex} />
              </div>
              <div className="buttons mt10">
                <ActionButton
                  alertType={item?.alertType}
                  data={item}
                />
              </div>
            </div>
          </>
        )}
      </div>
      {item?.bidCenterAlertDetails?.nextpossibleBidAmount && <div id={`alert-footer-${cardIndex}`} className="home-outbid-footer">
        Next bid increment: ${formatMoney(item?.bidCenterAlertDetails?.nextpossibleBidAmount, 0)}
      </div>}
      {item.type === "CIF_REMINDER" &&
        <div id={`alert-cif-section-${cardIndex}`} className="d-flex flex-column align-items-center justify-content-center text-center" style={{padding: '20px'}}>
           {item?.cifDetails?.timeLeft !== 0 && (
            <div id={`alert-cif-timer-${cardIndex}`} className="home-property-info ">
              <CountdownTimer
                until={item?.cifDetails?.timeLeft / 1000}
              />
            </div>
          )}
          <div className="buttons">
            <button
              type="button"
              id={`alert-cif-btn-${cardIndex}`}
              className=" outbid-btn home-outbid-btn-cif"
              style={{ backgroundColor: '#428bca', borderColor: '#428bca' }}
              data-bs-toggle="offcanvas"
              data-bs-target="#alertsSidebarListing"
              aria-controls="alertsSidebarListing"
              onClick={() => {
                dispatch(setSelectedAlert(data));
                handleAlertRefresh();
              }}
            >
              Complete CIF
            </button>
          </div>
        </div>
      }
    </div>
  );
};

export default HomeAlertCard;